<template>
    <div class="tool-detail" @click="closeDialog">
        <div class="tool-detail__wrapper" @click.stop v-loading="loading">
            <main class="tool-detail__wrapper-main">
                <h4 class="main-title">{{ title }}</h4>
                <div class="main-content">
                    <div v-html="content"></div>
                </div>
            </main>

            <div class="close-control" @click="closeDialog">
                <svg-icon icon-class="close" class-name="icon-close"></svg-icon>
            </div>
        </div>
    </div>
</template>

<script>
import { getToolDetail } from '@/api/tool';

export default {
    name: 'ToolMiniDetail',
    props: ['id'],
    data: () => ({
        loading: false,
        title: '',
        content: ''
    }),
    watch: {
        id() {
            this.getData();
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            this.loading = true;
            getToolDetail({ id: this.id }).then(({ code, data }) => {
                if (code === 0) {
                    this.title = data.title;
                    this.content = data.newtoolcontent;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        closeDialog() {
            this.$emit('closeDialog');
        }
    }
};
</script>

<style lang="scss" scoped>
.tool-detail {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.35);

    &__wrapper {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 900px;
        height: 500px;
        padding: 28px 79px 42px;
        background-color: #fff;
        border-radius: 6px;

        &-main {
            width: 100%;
            height: 100%;

            .main-title {
                height: 25px;
                line-height: 25px;
                text-align: center;
                margin-bottom: 20px;
                @include font(rgba(39, 44, 64, 1), 18px, 600);
            }

            .main-content {
                padding: 0 10px;
                height: 385px;
                line-height: 1.4;
                overflow: auto;
            }
        }

        .close-control {
            position: absolute;
            top: 20px;
            right: 25px;
            cursor: pointer;

            .icon-close {
                font-size: 15px;
                color: rgba(47, 84, 235, 0.5);

                &:hover {
                    color: rgba(47, 84, 235, 0.8);
                }
            }
        }
    }
}
</style>
